// Shared icon + color options for teams. The create form lets the user pick one
// of each; they're stored on the team doc (`teamIcon`, `teamColor`) and rendered
// back on the overview cards and the manage-members header.
import { Users, Scale, Landmark, ShieldCheck, Building2, Search } from "lucide-react";

export const TEAM_ICONS = [
  { key: "users", Icon: Users },
  { key: "scale", Icon: Scale },
  { key: "landmark", Icon: Landmark },
  { key: "shield", Icon: ShieldCheck },
  { key: "building", Icon: Building2 },
];

export const TEAM_ICON_MAP = {
  ...Object.fromEntries(TEAM_ICONS.map((i) => [i.key, i.Icon])),
  search: Search, // legacy: saved by teams before the picker dropped this option
};

export const TEAM_COLORS = [
  "#EAB308", // gold
  "#6366F1", // indigo
  "#3B82F6", // blue
  "#EC4899", // pink
  "#EF4444", // red
  "#F59E0B", // amber
  "#22C55E", // green
  "#14B8A6", // teal
];

export const DEFAULT_TEAM_ICON = "users";
export const DEFAULT_TEAM_COLOR = "#EAB308";

// "none" means the team was created without an icon — callers render a fallback
// (e.g. the team's initial) when this returns null.
export const getTeamIcon = (key) => (key === "none" ? null : TEAM_ICON_MAP[key] || Users);

// A soft translucent background for the given hex (10% alpha) for icon chips.
export const tintBg = (hex) => `${hex}1A`;
